import { ExperiencesGetPricingByKeyResponse } from '@flowio/api-sdk';
import ActionTypes from '../constants/action-types';
import { ThunkResult, ThunkExtraArguments } from '../../../stores/types';
import standardAction from '../../../utilities/standard-action';
import formatErrorResponseV2 from '../../../utilities/format-error-response-v2';
import toLegacyResponse from '../../../utilities/clients/to-legacy-response';
import { PropType } from '../../../types';
import { LegacyResponse } from '../../../utilities/clients/types/server';

type ResponseType = PropType<ExperiencesGetPricingByKeyResponse, 'body'>;

export default function getPricing(
  organization: string,
  experienceKey: string,
): ThunkResult<Promise<LegacyResponse<ResponseType>>> {
  return function getPricingEffects(
    dispatch,
    getState,
    extra: ThunkExtraArguments,
  ): Promise<LegacyResponse<ResponseType>> {
    dispatch({
      type: ActionTypes.GET_EXPERIENCE_PRICING_REQUEST,
    });
    return extra.api(getState()).experiences.getPricingByKey({
      organization,
      key: experienceKey,
    }).then((response) => {
      if (response.ok) {
        dispatch(standardAction(
          ActionTypes.GET_EXPERIENCE_PRICING_SUCCESS,
          response.body,
        ));
      } else {
        dispatch(standardAction(
          ActionTypes.GET_EXPERIENCE_PRICING_FAILURE,
          formatErrorResponseV2(response),
        ));
      }
      return toLegacyResponse<ResponseType>(response);
    });
  };
}
